import React, { useEffect, useState } from "react";
import { validate } from "../../util";
import { ScrollArea, Avatar, AvatarImage, useToast } from "../../components/ui";
import constant, { statuses, productTypeTranslate } from "../../constants";
import { MdDeleteOutline } from "react-icons/md";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header, UserPreview } from "../../components/modules";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import Context from "../../Context";
import { MdPersonSearch } from "react-icons/md";
import { RiStore2Line } from "react-icons/ri";
import { Spinner } from "../../components/ui";
import { useParams } from "react-router-dom";
import { resizeImage } from "../../util";
import { BiImageAdd } from "react-icons/bi";
import { FaXmark } from "react-icons/fa6";

export const CreateProductOrder = () => {
  const { toast } = useToast();
  const { userId } = useParams();
  const { callApi, navigate } = Context();
  const [user, setUser] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(false);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("richItem");

  useEffect(() => {
    getUsers();
    getProducts();
  }, [userId]);

  useEffect(() => {
    getProducts();
  }, [type]);

  const getUsers = async () => {
    const { status, data } = await callApi(
      "users-getUserInfoAdmin",
      {
        userId: userId,
      },
      {
        notShowLoading: true,
      }
    );

    if (status) {
      setUser(data);
    } else {
      toast({
        className: "bg-[#c15b78]",
        title: (
          <div className="flex gap-2 items-center">
            <FaTimes /> ไม่พบข้อมูลผู้ใช้งาน
          </div>
        ),
      });

      navigate("/users");
    }
  };

  const getProducts = async () => {
    setLoading(true);
    const result = await callApi(
      "products-getAll",
      {
        queries: [["type", type]],
        limit: 500,
        orderBy: ["createdAt", "desc"],
      },
      { notShowLoading: true }
    );
    setProducts(result || []);
    setLoading(false);
  };

  return (
    <div className="h-fit w-full min-w-[1200px] max-w-[1600px] mx-auto">
      {/* header */}
      <Header
        header="Products"
        subHeader={`สร้างคำสั่งซื้อสินค้า / ${userId}
`}
        icon={<RiStore2Line className="text-blue" />}
      />
      <div className="mt-3">
        {user ? (
          <UserPreview user={user} />
        ) : (
          <div className="flex h-[500px] justify-center items-center">
            <Spinner className="w-4 h-4" />
          </div>
        )}
      </div>
      <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
        {loading ? (
          <div className="flex h-[500px] justify-center items-center">
            <Spinner className="w-4 h-4" />
          </div>
        ) : selectedProduct ? (
          <CouponSelect
            // coupons={coupons}
            selectedProduct={selectedProduct}
            setSelectedProduct={setSelectedProduct}
            user={user}
          />
        ) : (
          <div>
            <div className="flex  items-center gap-3 p-3 border-b border-[#E5E7E9]">
              <p className="font-semibold text-xl">ประเภทสินค้า</p>
              <div>
                <select
                  className="border-1 w-full border-gray-300 py-[5px] px-2 font-semibold rounded-lg placeholder:text-sm disabled:opacity-40"
                  onChange={(e) => setType(e.target.value)}
                  value={type}
                >
                  {Object.entries(productTypeTranslate).map(([key, value]) => {
                    return <option value={key}>{value}</option>;
                  })}
                </select>
              </div>
            </div>
            <div className="grid grid-cols-5 gap-3 p-3">
              {products?.map((product) => {
                return (
                  <div
                    className="border border-muted rounded-md overflow-hidden"
                    key={product.id}
                  >
                    <div className="">
                      <img src={product.image} className="" alt={product.id} />
                    </div>

                    <p className="font-semibold text-lg mt-2 px-2 truncate">
                      {product.name}
                      {product.isHotDeal && " 🔥"}
                    </p>
                    <div
                      className={`${
                        product.status === statuses.ACTIVE
                          ? "bg-green"
                          : "bg-[#c15b78]"
                      } min-w-14 my-1 ml-2 w-fit px-2 py-1.5 font-semibold text-xs text-white text-center rounded-lg cursor-pointer`}
                    >
                      {product.status === statuses.ACTIVE
                        ? "พร้อมขาย"
                        : "ปิดขาย"}
                    </div>
                    <div className="grid grid-cols-2 gap-2 font-medium px-2">
                      <p>
                        ราคา:{" "}
                        <span className="font-semibold">
                          {product.price.toLocaleString() || 0}
                        </span>
                      </p>
                      <p>
                        คะแนน:{" "}
                        <span className="font-semibold">
                          {product.quantity.toLocaleString() || 0}
                        </span>
                      </p>
                    </div>
                    <div className="flex w-full">
                      <button
                        className="w-full font-semibold text-white py-1.5 mt-2 mx-2 mb-2 hover:opacity-65 duration-150 bg-navy rounded-md "
                        onClick={() => {
                          setSelectedProduct(product);
                        }}
                      >
                        เลือก
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// const ProductList = ({}) => {
//   return (
//     <div>
//       <div className="flex  items-center gap-3 p-3 border-b border-[#E5E7E9]">
//         <p className="font-semibold text-xl">
//           ข้อมูลผู้ซื้อ <span className="text-green">#{user.userId}</span>
//         </p>
//       </div>
//     </div>
//   );
// };

const CouponSelect = ({ setSelectedProduct, selectedProduct, user }) => {
  const { toast } = useToast();
  const { callApi, profileState } = Context();
  const [previewImage, setPreviewImage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [body, setBody] = useState({
    id: selectedProduct.id,
    name: user.firstName + " " + user.lastName,
    phone: user.phone,
    address:
      user.address.addr +
      " " +
      user.address.province +
      " " +
      user.address.zipcode,
    note: "",
    userId: user.userId,
    createdByAdmin: true,
    createdBy: {
      firstName: profileState.firstName,
      lastName: profileState.lastName,
      phone: profileState.phone,
      userId: profileState.userId,
    },
  });
  console.log("selectedProduct", selectedProduct);

  return (
    <div>
      {loading && (
        <div className="absolute w-full z-50 h-full bg-[rgb(255,255,255,0.6)] flex items-center justify-center">
          <Spinner className="w-4 h-4" />
        </div>
      )}
      <div className="flex items-center gap-4 p-3 border-b border-[#E5E7E9] justify-between">
        <p className="font-semibold text-xl">สร้างคำสั่งซื้อร้านค้า</p>
        <FaXmark
          className="text-lg text-red-600 cursor-pointer"
          onClick={() => setSelectedProduct(false)}
        />
      </div>
      <div className="p-3 grid grid-cols-4 gap-3">
        <div className="row-span-6">
          <img
            src={selectedProduct.image || ""}
            alt={selectedProduct?.shortId}
            className=""
          />
        </div>
        <div>
          <p className="font-medium">สินค้า</p>
          <div className="flex">
            <input
              className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
              type="text"
              disabled={true}
              value={selectedProduct?.name || ""}
              onChange={(e) => {}}
            />
          </div>
        </div>
        <div>
          <p className="font-medium">ประเภทสินค้า</p>
          <div className="flex">
            <input
              className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
              type="text"
              disabled={true}
              value={productTypeTranslate[selectedProduct?.type] || ""}
              onChange={(e) => {}}
            />
          </div>
        </div>
        <div>
          <p className="font-medium">สถานะสินค้า</p>
          <div
            className={`${
              selectedProduct.status === statuses.ACTIVE
                ? "bg-green"
                : "bg-[#c15b78]"
            } min-w-14 px-2 py-1.5 font-semibold text-white text-center rounded-lg cursor-pointer`}
          >
            {selectedProduct.status === statuses.ACTIVE ? "พร้อมขาย" : "ปิดขาย"}
          </div>
        </div>
        <div>
          <p className="font-medium">ราคา</p>
          <div className="flex">
            <input
              className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
              type="text"
              disabled={true}
              value={selectedProduct?.price || ""}
              onChange={(e) => {}}
            />
          </div>
        </div>

        <div>
          <p className="font-medium">สินค้าคงเหลือ</p>
          <div className="flex">
            <input
              className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
              type="text"
              disabled={true}
              value={selectedProduct?.quantity || ""}
              onChange={(e) => {}}
            />
          </div>
        </div>
        <div></div>
        <div>
          <p className="font-medium">ชื่อ-นามสกุล ผู้ซื้อ</p>
          <div className="flex">
            <input
              className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
              type="text"
              value={body?.name || ""}
              onChange={(e) => {
                setBody((prevState) => ({
                  ...prevState,
                  name: e.target.value,
                }));
              }}
            />
          </div>
        </div>
        <div>
          <p className="font-medium">เบอร์โทรศัพท์ ผู้ซื้อ</p>
          <div className="flex">
            <input
              className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
              type="text"
              value={body?.phone || ""}
              onChange={(e) => {
                setBody((prevState) => ({
                  ...prevState,
                  phone: e.target.value,
                }));
              }}
            />
          </div>
        </div>
        <div>
          <p className="font-medium">ที่อยู่ ผู้ซื้อ</p>
          <div className="flex">
            <input
              className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
              type="text"
              value={body?.address || ""}
              onChange={(e) => {
                setBody((prevState) => ({
                  ...prevState,
                  address: e.target.value,
                }));
              }}
            />
          </div>
        </div>
        <div className="col-span-3">
          <p className="font-medium">หมายเหตุคำสั่งซื้อ</p>
          <div className="flex">
            <textarea
              className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
              type="text"
              value={body?.note || ""}
              onChange={(e) => {
                setBody((prevState) => ({
                  ...prevState,
                  note: e.target.value,
                }));
              }}
            />
          </div>
        </div>
        <div className="w-full h-full col-span-3 flex justify-center items-center">
          {previewImage ? (
            <div className="flex flex-col justify-center items-center gap-2">
              <img
                src={previewImage}
                className="max-w-[300px] max-h-[500px]"
                alt="preview"
              />
              <button
                className={`h-10 w-fit px-2 bg-[#c15b78] flex gap-1 justify-center items-center text-sm text-white hover:opacity-85 duration-200 disabled:hover:bg-gray-950 font-bold rounded-[0.5rem] disabled:cursor-not-allowed disabled:opacity-50`}
                onClick={() => {
                  setPreviewImage(false);
                  setBody((prevState) => ({
                    ...prevState,
                    image: false,
                  }));
                }}
              >
                ลบสลิป
              </button>
            </div>
          ) : (
            <label
              className="flex w-full h-full py-1 bg-blue text-white hover:opacity-75 cursor-pointer duration-150 gap-2 items-center justify-center rounded-lg"
              htmlFor="image"
            >
              <BiImageAdd className="w-6 h-6" />
              <p className="font-semibold">อัปโหลดสลิป</p>
            </label>
          )}
          <input
            style={{
              visibility: "hidden",
              position: "absolute",
              display: "none",
            }}
            id="image"
            type="file"
            onChange={async (e) => {
              const file = e.target.files[0];
              const previewImage64 = await resizeImage(file);
              if (previewImage64) {
                const previewUrl = URL.createObjectURL(file);
                setPreviewImage(previewUrl);
                setBody((prevState) => ({
                  ...prevState,
                  image: previewImage64,
                }));
              } else {
                alert("อัพโหลด ได้เฉพาะ ไฟล์รูปภาพ นามสกุล jpg หรือ png");
              }
            }}
          />
        </div>

        <button
          disabled={!selectedProduct.id}
          className="col-span-3 bg-green  py-1.5 px-3 font-semibold flex justify-center items-center gap-2 text-white hover:opacity-85 disabled:opacity-55 rounded-md"
          onClick={async () => {
            setLoading(true);
            const { status, orderId } = await callApi(
              "products-createTransaction",
              body,
              { notShowLoading: true }
            );
            if (status) {
              toast({
                className: "bg-green",
                title: (
                  <div className="flex gap-2 items-center">
                    <FaCheckCircle /> สร้างคำสั่งซื้อสำเร็จ
                  </div>
                ),
              });

              window.open(`/product/order/${orderId}`);
              window.location.reload();
            } else {
              toast({
                className: "bg-[#c15b78]",
                title: (
                  <div className="flex gap-2 items-center">
                    <FaTimes /> {"ไม่สามารถสร้างคำสั่งซ์ื้อได้"}
                  </div>
                ),
              });
            }
            setLoading(false);
          }}
        >
          สร้างออเดอร์
        </button>
      </div>
    </div>
  );
};
